import React from "react";
import { observer } from "mobx-react";
import { CountryCreateStore } from "../../store";
import { CountryCreateForm } from "./CountryCreateForm";
import { ErrorDialog } from "../../../../common/controls";
import { SavingOverlay } from "../../../../common/controls/forms/SavingOverlay";

export type CountryCreateProps = {
  countryCreateStore: CountryCreateStore;
  showToolbox?: boolean;
  showSaveFooter?: boolean;
};

export const CountryCreate: React.FC<CountryCreateProps> = observer(
  ({ countryCreateStore, showToolbox = true, showSaveFooter }) => {
    return (
      <>
        <SavingOverlay open={countryCreateStore.isSaving} />
        <CountryCreateForm
          countryCreateStore={countryCreateStore}
          name_esError={countryCreateStore.errors.name_es?.message}
          onName_esChange={(value: string) => {
            countryCreateStore.setName_esValue(value);
          }}
          name_es={countryCreateStore.entityValues.name_es}
          name_enError={countryCreateStore.errors.name_en?.message}
          onName_enChange={(value: string) => {
            countryCreateStore.setName_enValue(value);
          }}
          name_en={countryCreateStore.entityValues.name_en}
          name_ptError={countryCreateStore.errors.name_pt?.message}
          onName_ptChange={(value: string) => {
            countryCreateStore.setName_ptValue(value);
          }}
          name_pt={countryCreateStore.entityValues.name_pt}
          codeError={countryCreateStore.errors.code?.message}
          onCodeChange={(value: string) => {
            countryCreateStore.setCodeValue(value);
          }}
          code={countryCreateStore.entityValues.code}
          currencyError={countryCreateStore.errors.currency?.message}
          onCurrencyChange={(value: string) => {
            countryCreateStore.setCurrencyValue(value);
          }}
          currency={countryCreateStore.entityValues.currency}
          demonym_esError={countryCreateStore.errors.demonym_es?.message}
          onDemonym_esChange={(value: string) => {
            countryCreateStore.setDemonym_esValue(value);
          }}
          demonym_es={countryCreateStore.entityValues.demonym_es}
          demonym_enError={countryCreateStore.errors.demonym_en?.message}
          onDemonym_enChange={(value: string) => {
            countryCreateStore.setDemonym_enValue(value);
          }}
          demonym_en={countryCreateStore.entityValues.demonym_en}
          demonym_ptError={countryCreateStore.errors.demonym_pt?.message}
          onDemonym_ptChange={(value: string) => {
            countryCreateStore.setDemonym_ptValue(value);
          }}
          demonym_pt={countryCreateStore.entityValues.demonym_pt}
          showToolbox={showToolbox}
          showSaveFooter={showSaveFooter}
          saving={countryCreateStore.isProcessing}
          onSave={() => countryCreateStore.saveNewCountry()}
          onCancel={() => countryCreateStore.cancelNewCountry()}
        />
        <ErrorDialog
          open={countryCreateStore.errorDialogOpened}
          title={countryCreateStore.errorTitle}
          description={countryCreateStore.errorDescription}
          onClose={() => countryCreateStore.closeErrorDialog()}
        />
      </>
    );
  }
);
